export const staticNoticias = [
  // Veda News
  {
    imagen: "/assets/imgs/carousel-imgs/desktop/banner_veda.png",
    url: "",
    titulo: "",
    fecha: "",
  },
  // {
  //   imagen: "https://pbs.twimg.com/media/GE-0NIJXYAA0EBb?format=jpg&name=large",
  //   url: "https://twitter.com/CAASIM/status/1751816932024541443/photo/1",
  //   titulo:
  //     '"⚠️ATENCIÓN ⚠️ Aviso importante para los usuarios"',
  //   fecha: "",
  // },
  // {
  //   imagen:
  //     "https://pbs.twimg.com/media/GFB-1QkWYAAH3yl?format=jpg&name=large",
  //   url: "https://twitter.com/CAASIM/status/1752039720652038498/photo/1",
  //   titulo: "¡CAASIM da inicio a reparaciones de fugas! ",
  //   fecha: "",
  // },
];
